<template>
  <vs-popup title="Relatório de Desconexões" :active.sync="isActive" @close="close()">
    <div class="d-flex">
      <flat-pickr
          :config="flatpickr"
          v-model="startAt"
          name="Período (de)"
          placeholder="Escolha um dia"
          v-validate="'required'"
      />

      <flat-pickr
        :config="finishAtConfig(flatpickr)"
        v-model="finishAt"
        name="Período (até)"
        placeholder="Escolha um dia"
        v-validate="'required'"
        :disabled="startAt === ''"
        class="ml-4"
      />

      <vs-button
        class="ml-4 w-full"
        type="filled"
        @click="getInstanceLogs"
        :disabled="disableDownload"
      > Gerar </vs-button>
    </div>
    <br>
    <ul class="ulOrderSheet">
      <li :data="url" :key="date" v-for="(url, date) in instanceLogsData">
        <span> Relatório de Desconexões do Dia {{ parseDate(date, true) }} </span> <a :href="url" target="_blank">Clique aqui para baixar</a>
      </li>
    </ul>
  </vs-popup>
</template>

<script>
import {mapGetters} from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'InstanceLogsReport',
  components: {flatPickr},
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['token']),
    disableDownload(){
      return !this.startAt || !this.finishAt || this.startAt === '' || this.finishAt === ''
    }
  },
  data() {
    return {
      startAt: '',
      finishAt: '',
      instanceLogsData: {},
      flatpickr: {
        enableTime: false,
        noCalendar: false,
        dateFormat: "d/m/Y",
        locale: Portuguese
      }
    }
  },
  methods: {
    close() {
      this.startAt = '';
      this.finishAt = '';
      this.instanceLogsData = {};
      this.$emit('isActiveFalse');
    },
    finishAtConfig(config) {
      return {
        ...config,
        minDate: this.startAt
      }
    },
    parseDate(dateString, toBrazilian = false) {
      if (!dateString) return dateString;
      const parts = dateString.split(toBrazilian ? '-' : '/');
      return toBrazilian ? `${parts[2]}/${parts[1]}/${parts[0]}` : `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    getInstanceLogs() {
      this.$vs.loading();
      this.$store.dispatch('getInstanceLogs', {
        startAt: this.parseDate(this.startAt),
        finishAt: this.parseDate(this.finishAt),
        token: this.token
      }).then(response => this.instanceLogsData = response.data).catch(exception => {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      });
      this.$vs.loading.close();
    }
  },
  watch: {
    isActive(value) {
      if (!value) {
        this.instanceLogsData = {};
        this.startAt = '';
        this.finishAt = '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ulOrderSheet {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 10px 0;
    padding: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
  }
  span {
    font-weight: bold;
    color: #555;
  }
  a {
    color: #007bff;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  }
}
</style>
